import React from 'react'
import t from '~t'
import { Section } from '~ui'

export default function SearchMenuSuggestionsTip({ suggestions, value }) {
    if (!suggestions.length)
        return null

    if (suggestions[0].query?.startsWith('created'))
        return (<Section className={'ui-search-tip'}>{t.s('dateSearchD')}</Section>)

    if (suggestions[0]._id != 'current')
        return (<Section>{value ? t.s('narrowSearch') : t.s('suggested')}</Section>)

    return null
}